import './scss/style.scss';
import 'react-toastify/dist/ReactToastify.css';
import '@coreui/coreui/dist/css/coreui.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Routing } from './components';
function App() {
    return <Routing />;
}

export default App;
